<div class="max-w-lg mx-auto h-[100svh]">

  <!-- Background image -->
  <div class="absolute inset-0 bg-cover bg-top bg-no-repeat"
       [style.backgroundImage]="'url(' + imageUrl + ')'">
  </div>

  <!-- Overlay -->
  <div class="absolute inset-0 bg-theme-surface-50"></div>

  <div class="relative flex flex-col h-full">
    <div class="flex flex-col justify-center items-center mt-24">
      <div class="mb-4">
        <ng-container *ngIf="logoUrl; else noImage">
          <img [src]="logoUrl" alt="Logo" class="w-full h-auto px-16">
        </ng-container>
        <ng-template #noImage>
          <div class="text-center text-8xl font-extrabold text-theme-primary p-4">
            {{ getVenueName() }}
          </div>
        </ng-template>
      </div>

    <div class="mx-16 text-center text-xl font-bold mt-2 mb-2 min-h-20">
      <!-- TODO: Add welcome text -->
      <!-- {{ getString("Välkommen!") }} -->
    </div>
    </div>
    <div class="rounded-t-3xl backdrop-blur-xl bg-theme-surface-50 flex flex-col justify-start items-center flex-1">

      <div class="w-full px-12 mt-8" *ngIf="!isNewVisit && !fromBook">
        <app-plain-button [text]="getString('Tillbaka till menyn')" bgColor="bg-theme-primary"  icon="fa-solid fa-plate-utensils" color="text-theme-contrast" [customClass]="'h-14'"
        (onClick)="navMenu()"></app-plain-button>
      </div>

      <div class="w-full px-12 mt-8" *ngIf="bookingEnabled">
        <app-plain-button [text]="getString('Boka bord')" bgColor="bg-theme-primary" icon="fa-solid fa-calendar-check" color="text-theme-contrast" [customClass]="'h-14'"
        (onClick)="navBook()"></app-plain-button>
      </div>

      <div class="text-theme-text text-2xl font-bold pt-6 pb-2 my-6" *ngIf="(list?.length??0)>0 || fromBook">{{callout}}</div>
      <div *ngFor="let it of list" class="w-full px-12 pb-6">
        <app-border-icon-button [text]="getString(it.title)" (onClick)="openLink($event, it.key)" rightIcon="fa-chevron-circle-right"></app-border-icon-button>
        <div class="text-base text-theme-text px-4 font-normal break-words mt-1">{{getString(it.desc)}}</div>
      </div>

      <div class="text-base text-theme-text2 mt-16 flex flex-col items-center">
        <div class="underline cursor-pointer" *ngIf="menuOfTheWeek()" (click)="navMenuOfTheWeek()">
          <i class="fas fa-calendar-alt mr-2"></i>{{getString("Se veckans meny")}}
        </div>
      </div>

      <div class="text-sm text-theme-text2 text-center py-4 mt-auto mb-4">
        heynow
      </div>

      <!-- Spinner and backdrop  -->
      <div *ngIf="isLoading"
           class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
        <app-loading-spinner size="xl"></app-loading-spinner>
      </div>
    </div>

  </div>

</div>
